import { evalBinding } from '../../lib/bindings';

export default function HeaderBlock({ block, data }: any) {
  const logo = block.logo && evalBinding(block.logo, data);
  const cls = (block.className ? block.className + ' ' : '') + 'header card';

  return (
    <div className={cls} style={{ background: 'var(--bgCard)' }}>
      <div>{logo ? <img src={logo} alt="logo" /> : null}</div>
      <div className="title" style={{ textAlign: block.align ?? 'right' }}>
        <div className="h1">{evalBinding(block.title, data)}</div>
        {block.subtitle && <div className="muted">{evalBinding(block.subtitle, data)}</div>}
      </div>
    </div>
  );
}
